/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";
import { Tooltip, toggleClass, } from '@grapecity/wijmo';
import "./gridEvent.css"

function TkMaterialAttribute(props) {
    const table = "TkMaterialAttribute";
    const view = "TkVwMaterialAttribute";
    const id = "TkMaterialAttribute";

    const { t } = useTranslation();

    const [tkMaterialAttributeSchema, setTkMaterialAttributeSchema] = useState();
    const [tkMaterialAttributeGrid, setTkMaterialAttributeGrid] = useState();
    const [tkMaterialAttributeApi, setTkMaterialAttributeApi] = useState();
    const [tkMaterialAttributeDataIsEmpty, setTkMaterialAttributeDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setTkMaterialAttributeSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);
    
    useEffect(() => {
        let tooltip = new Tooltip();
        (async () => {
            if (tkMaterialAttributeGrid) {
                tkMaterialAttributeGrid.formatItem.addHandler((flex, element) => {
                    if (element.panel === flex.cells) {
                        let item = flex.rows[element.row].dataItem
                        let binding = flex.columns[element.col].binding
                        let data = item.description ? item.description : null;
                        toggleClass(element.cell, 'wj-has-notes', binding === "description" && data !== null );
                        if(binding === "description" && data !== null) {
                            tooltip.setTooltip(element.cell, `<h1>${data}<h1>`);
                        }
                    }
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tkMaterialAttributeGrid]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.tkMaterialAttribute")}
            table={table}
            view={view}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setTkMaterialAttributeGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkMaterialAttributeApi(api);
            }}
            onLoadData={(data) => {
                const isEmpty = data.length < 1 ? true : false;
                setTkMaterialAttributeDataIsEmpty(isEmpty);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkMaterialAttributeSchema && tkMaterialAttributeSchema.name}
                        accessMethod="POST"
                    >
                        <CreateRecordButton
                            id={id}
                            schema={tkMaterialAttributeSchema}
                            refresh={tkMaterialAttributeApi}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkMaterialAttributeSchema && tkMaterialAttributeSchema.name}
                        accessMethod={
                            tkMaterialAttributeSchema && (tkMaterialAttributeSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={tkMaterialAttributeSchema}
                            grid={tkMaterialAttributeGrid}
                            refresh={tkMaterialAttributeApi}
                            disabled={tkMaterialAttributeDataIsEmpty}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkMaterialAttributeSchema && tkMaterialAttributeSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteSingleRecordButton
                            id={id}
                            schema={tkMaterialAttributeSchema}
                            grid={tkMaterialAttributeGrid}
                            refresh={tkMaterialAttributeApi}
                            makeItemName={(row) => {
                                return `${t("columnName.material")}: ${row.material}`;
                            }}
                            color="secondary"
                            disabled={tkMaterialAttributeDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default TkMaterialAttribute;
